import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home              = () => import(/* webpackChunkName: "home"               */ '../views/Home'),
      LightningDistance = () => import(/* webpackChunkName: "lightning-distance" */ '../views/LightningDistance'),
      FaceRecognition   = () => import(/* webpackChunkName: "face-recognition"   */ '../views/FaceRecognition'),
      MediaStream       = () => import(/* webpackChunkName: "media-stream"       */ '../views/MediaStream'),
      MediaStreamHome   = () => import(/* webpackChunkName: "media-stream-home"  */ '../views/MediaStream/Home'),
      MediaStreamRoom   = () => import(/* webpackChunkName: "media-stream-room"  */ '../views/MediaStream/Room'),
      NotFound          = () => import(/* webpackChunkName: "not-found"          */ '../views/404'),
      Bolao             = () => import(/* webpackChunkName: "bolao"              */ '../views/Bolao')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/lightning-distance',
    name: 'LightningDistance',
    component: LightningDistance,
    meta: {
      title: 'Lightning Distance Calculator'
    }
  },
  {
    path: '/face-recognition',
    name: 'FaceRecognition',
    component: FaceRecognition,
    meta: {
      title: 'Face Recognition'
    }
  },
  {
    path: '/media-stream',
    component: MediaStream,
    children: [
      {
        path: '',
        name: 'MediaStream',
        component: MediaStreamHome,
        meta: {
          title: 'Media Stream'
        }
      },
      {
        path: ':room',
        name: 'MediaStreamRoom',
        component: MediaStreamRoom,
        meta: {
          title: 'Media Stream - Room'
        }
      }
    ]
  },
  {
    path: '/bolao',
    name: 'Bolao',
    component: Bolao,
    meta: {
      title: 'Bolão'
    }
  },
  {
    path: '*',
    name: '404',
    component: NotFound,
    meta: {
      title: 'Not Found!'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
